{
    "RingtimeDistributionLabel": "Ring Time (Distribution):",
    "RingtimeSegmentLabel": "Ring Time (Segment):",
    "CalltalktimeLabel": "Call Talk Time (Segment):",
    "TotalcalltimeLabel": "Total Call Time:",
    "CallheldtimeLabel": "Call Held Time (Segment):",
    "TimeComparisonAnyOptionLabel": "[Any]",
    "TimeComparisonHigherthanOptionLabel": "Higher Than",
    "TimeComparisonHigherequalOptionLabel": "Higher/Equal",
    "TimeComparisonLowerthanOptionLabel": "Lower Than",
    "TimeComparisonLowerequalOptionLabel": "Lower/Equal",
    "TimeComparisonBetweenOptionLabel": "Between",
    "TimeComparisonEqualOptionLabel": "Equal",
    "TimeComparisonNotequalOptionLabel": "Not Equal",
    "TimeComparisonNotbetweenOptionLabel": "Not Between",
    "TimeComparisonValue1Label": "Value:",
    "TimeComparisonValue2Label": "And:",
    "NAME": "DurationFiltering",
    "DurationFiltering_SectionHeader": "Duration Filtering (Historic Only)"
}